import {Routes} from '@angular/router';
import {LoginComponent} from './features/auth/login/login.component';
import {DashboardComponent} from './features/dashboard/dashboard.component';
import {ForgotPasswordComponent} from './features/auth/forgot-password/forgot-password.component';
import {authGuard} from "./core/api/auth.guard";
import {SignupApplicationsComponent} from './features/signup-applications/signup-applications.component';
import {LayoutComponent} from './features/layout/layout.component';
import {CompanyListComponent} from "./features/companies/company-list/company-list.component";
import {CompanyDetailsComponent} from "./features/companies/company-list/company-details/company-details.component";
import {UsersComponent} from "./features/users/pages/users.component";
import {SetupPasswordComponent} from "./features/auth/setup-password/setup-password.component";
import {ResetPasswordComponent} from "./features/auth/reset-password/reset-password.component";
import {
  LinkCompanyToTenantComponent
} from "./features/tenants/component/link-company-to-tenant/link-company-to-tenant.component";
import {TenantsComponent} from "./features/tenants/component/pages/tenants/tenants.component";

export const routes: Routes = [
  {path: '', redirectTo: '/login', pathMatch: 'full'},
  {path: 'login', component: LoginComponent},
  {path: 'forgot-password', component: ForgotPasswordComponent},
  {path: 'setup-password/:token', component: SetupPasswordComponent},
  {path: 'reset-password/:token', component: ResetPasswordComponent},
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      {path: 'dashboard', component: DashboardComponent},
      {path: 'companies', component: CompanyListComponent},
      {path: 'companies/:id', component: CompanyDetailsComponent},
      {path: 'company-applications', component: SignupApplicationsComponent},
      {path: 'users', component: UsersComponent},
      {path: 'tenants', component: TenantsComponent}
    ]
  },
];
